import { IAppState } from '../common/state';
import { isCommercial, offerTypeFromJsonQuery } from '../utils/category';

export function isRedesignExperimentEnabled(state: IAppState) {
  return !isCommercial(offerTypeFromJsonQuery(state.results.jsonQuery)) && state.isRedesignEnabled;
}
